module.exports = __webpack_public_path__ + "assets/images/EUR500.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR500.png
// module id = 1370
// module chunks = 1